import { FunctionComponent } from 'react';
import styled from 'styled-components';

interface IconContainerProps {
  color: string;
}

export const DashboardLayout = styled.div`
  .ant-layout-content {
    section {
      background: transparent;
    }
  }
  .ant-layout-footer {
    display: none;
  }
`;

export const DashboardTitle = styled.h1`
  font-family: Nunito;
  font-weight: bold;
  color: black;
  font-size: 1.625rem;
  line-height: 2.188rem;
  text-align: center;
  margin-bottom: 4.5rem;
`;

export const DashboardAppsNavigation = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;

  > div {
    margin: 0.8rem;
  }
`;

export const ApplicationItemStyled = styled.div`
  width: 24.313rem;
  height: 8.25rem;
  border: 0.063rem solid #f0f0f0;
  box-sizing: border-box;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.07);
  border-radius: 0.125rem;
  background: white;
  display: flex;
  align-items: center;
  padding: 1.5rem;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`;

export const IconContainerStyled: FunctionComponent<IconContainerProps> = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 5.25rem;
  height: 5.25rem;
  background: linear-gradient(0deg, #4d8278, #4d8278), #66af37;
  border-radius: 6.25rem;

  background: ${(props: IconContainerProps) => props.color};

  .anticon {
    font-size: 2.25rem;
    color: rgba(255, 255, 255, 0.85);
  }
`;

export const TextContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  div {
    display: flex;
    flex-direction: row;

    div {
      font-weight: 600;
      font-size: 1.313rem;
      line-height: 1.375rem;
      span:nth-child(1) {
        font-weight: normal;
        color: rgba(0, 0, 0, 0.35);
        position: relative;
        top: 0.625rem;
        right: 0.313rem;
        font-size: 1.438rem;
      }

      span:nth-child(2) {
        position: relative;
        top: 0.688rem;
      }
    }
  }
`;

export const ApplicationItemTitleStyled = styled.span`
  position: relative;
  left: 1rem;
  bottom: 0.438rem;
  letter-spacing: -0.03em;
  color: rgba(0, 0, 0, 0.65);
`;

export const DashboardFooter = styled.div`
  position: absolute;
  bottom: 1rem;
  width: 100%;
  text-align: center;
  font-style: normal;
  font-weight: normal;
  font-family: Nunito;
  font-size: 0.93rem;
  line-height: 1.375rem;
  letter-spacing: -0.03em;
  color: black;
`;

export const DashboardLoading = styled.section`
  color: rgba(0, 0, 0, 0.4);
  font-size: 1.5rem;
  text-align: center;
  padding: 4rem 0;
`;
